// @ts-nocheck
/* eslint-disable */
export const appCloseV216Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 10.83L10.83 13.66L13.66 10.83L10.83 8L13.66 5.17L10.83 2.34L8 5.17L5.17 2.34L2.34 5.17L5.17 8L2.34 10.83L5.17 13.66L8 10.83Z" fill="currentColor"/></svg>`,
    name: 'close-v-2-16' as const
};